import React from "react";

const MainLayout = ({ hideHeader, hideSidebar, Header, SideBar, Component }) => {
  const renderHeader = () => Header;
  const renderSideBar = () => SideBar;
  const renderComponent = () => Component;

  return (
    <div className="layout-main ">
      {!hideHeader && (
        <div className={hideSidebar ? "main-head-parent toggleiconhideshow " : "main-head-parent"}>
          {renderHeader()}
        </div>
      )}
      <div className={`${hideHeader ? "no-header" : ""} body-n-side `}>
        {!hideSidebar && <div className="sidebar-main">{renderSideBar()}</div>}
        <div className="content-main">{renderComponent()}</div>
      </div>
    </div>
  );
};

export default MainLayout;
